"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DumbappBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
var _variables2 = require("@blockwell/dumbapp/lib/variables");
const settings = [{
  title: "Dumbapp",
  settings: _variables2.DumbappVariable.settings
}, {
  title: "Arguments",
  settings: {
    values: {
      type: "args",
      title: "Values",
      description: "Argument values to fill in the dumbapp with.",
      form: true
    }
  }
}, {
  title: "Display",
  settings: {
    layout: {
      type: "select",
      title: "Layout",
      description: "How to layout the dumbapp UI.",
      enum: ["below", "right"],
      default: "below"
    },
    label: {
      type: "var",
      title: "Label",
      description: "Label for the button.",
      default: "Submit"
    },
    disabled: {
      type: "conditions",
      title: "Disable Conditions",
      description: "Disable the button when these conditions are met."
    }
  }
}, {
  title: "Result",
  settings: {
    variable: {
      type: "def",
      description: "Optionally save the dumbapp status to a variable.",
      default: {
        name: "submission"
      }
    }
  }
}];
class DumbappBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "dumbapp");
    (0, _defineProperty2.default)(this, "noChildren", true);
    (0, _defineProperty2.default)(this, "dumbappVariable", void 0);
    (0, _defineProperty2.default)(this, "argsVariable", void 0);
    (0, _defineProperty2.default)(this, "layoutVariable", void 0);
    (0, _defineProperty2.default)(this, "labelVariable", void 0);
    (0, _defineProperty2.default)(this, "resultVariable", void 0);
    (0, _defineProperty2.default)(this, "disabledVariable", void 0);
    (0, _defineProperty2.default)(this, "walletVariable", void 0);
    this.param = param;
    this.dumbappVariable = this.addBlockVariable(variableTypes.get("dumbapp"), param, ["shortcode"]);
    this.argsVariable = this.addBlockVariable(variableTypes.get("dumbapp-arguments"), param, ["values"]);
    this.layoutVariable = this.addBlockVariable(variableTypes.get("literal"), param, [["layout", "value"]]);
    this.labelVariable = this.addBlockVariable(variableTypes.get("pointer"), param, [["label", "ref"]]);
    this.resultVariable = this.addBlockVariable(new _variables2.DumbappResultVariable(), param, ["shortcode"], {
      key: "variable",
      default: "submission"
    });
    this.disabledVariable = this.addBlockVariable(variableTypes.get("condition"), param, [["disabled", "conditions"]]);
    this.walletVariable = this.addBlockVariable(variableTypes.get("pointer"), {
      ref: {
        type: "var",
        param: {
          type: "wallet"
        }
      }
    });
  }
  renderValue() {
    var _vals$value;
    let dumbapp = null;
    let values = null;
    let value = this.dumbappVariable.value();
    if ((value === null || value === void 0 ? void 0 : value.type) === "dumbapp") {
      dumbapp = value.value;
    }
    const args = this.argsVariable.value();
    if (_variables.vals.isMeta(args) && _variables.vals.metaType(args) === "dumbapp-arguments") {
      values = {
        value: _variables.vals.array(args),
        form: args.value.form,
        names: args.value.names,
        prefill: args.value.prefill
      };
    }
    return {
      dumbapp,
      layout: _variables.vals.stringValue(this.layoutVariable.value()) || "button",
      label: _variables.vals.stringValue(this.labelVariable.value()) || "Submit",
      values,
      result: _variables.vals.value(this.resultVariable.value()),
      disabled: _variables.vals.truthy(this.disabledVariable.value()),
      walletType: (_vals$value = _variables.vals.value(this.walletVariable.value())) === null || _vals$value === void 0 ? void 0 : _vals$value.type
    };
  }
}
exports.DumbappBlock = DumbappBlock;
(0, _defineProperty2.default)(DumbappBlock, "settings", settings);
//# sourceMappingURL=DumbappBlock.js.map